import axios from "axios";
import { handleError } from "../handleError";
import { LError } from "../../object";
const state = {};
const getters = {};
const mutations = {};
const actions = {
  /* 获取已部署流程id */
  async getDeployedProcess({ dispatch }) {
    let url = "/rocApi/roc/process/list";
    let method = "get";
    let res = null;
    try {
      let config = { url, method };
      res = await axios(config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取当前用户的信息 */
  async getUserInfo({ dispatch }, loginId) {
    let url = "/shiroApi/user/list?page=0&size=10";
    try {
      let res = null;
      res = await axios.post(url, {
        searchParam: {
          loginId: {
            index: 1,
            operators: [
              {
                keyword: loginId,
                matchType: "NONE",
                operator: "EQ"
              }
            ],
            order: "DESC"
          }
        }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 当前用户获取该用户提交的函件预约申请列表 */
  async getLetterReservations(
    { dispatch },
    { pagination, filter, sortStack, search }
  ) {
    let url = "/rocApi/roc/process/instance/his/applicant/list";
    let loginInfo = eval("(" + sessionStorage.getItem("loginInfo") + ")");
    let params = {
      pagingStart: (pagination.page - 1) * pagination.rowsPerPage,
      pagingSize: pagination.rowsPerPage,
      procDefId: sessionStorage.getItem("processId"),
      assignee: loginInfo.id,
      type: filter === "" || filter === undefined ? "0" : filter
    };
    try {
      // let config = {url, method, ...params}
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 管理员获取已提交的函件预约申请列表 */
  async getLetterReservations_Manager(
    { dispatch },
    { pagination, filter, sortStack, search }
  ) {
    let url = "/rocApi/roc/process/instance/his/review/list";
    let loginInfo = eval("(" + sessionStorage.getItem("loginInfo") + ")");
    let params = {
      pagingStart: (pagination.page - 1) * pagination.rowsPerPage,
      pagingSize: pagination.rowsPerPage,
      procDefId: sessionStorage.getItem("processId"),
      assignee: loginInfo.id,
      type: filter === "" || filter === undefined ? "0" : filter
    };
    try {
      // let config = {url, method, ...params}
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 新增函件预约，开启新的流程实例 */
  async createReservation({ dispatch }, config) {
    let url = "/rocApi/roc/process/instance";
    let loginInfo = eval("(" + sessionStorage.getItem("loginInfo") + ")");
    try {
      let res = null;
      res = await axios.post(url, config);
      if (res.data.code + "" === "200") {
        return dispatch("editReservation", {
          assignee: loginInfo.id,
          procInstId: res.data.data.processInstanceId,
          groups: ["user"]
        });
      } else {
        return res;
      }
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 追加函件预约 */
  async appendReservation({ dispatch }, config) {
    let url = "/rocApi/roc/process/instance/add";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 编辑函件预约，查询该函件预约任务 */
  async editReservation({ dispatch }, config) {
    let url = "/rocApi/roc/task/todo";
    try {
      let res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 撤销函件预约 */
  async cancelReservation({ dispatch }, procInstId) {
    let url = "/rocApi/roc/task/change/" + procInstId;
    try {
      let res = null;
      res = await axios.put(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 删除函件预约-用户端 */
  async deleteReservation_user({ dispatch }, procInstId) {
    let url = "/rocApi/roc/process/instance/cancel/" + procInstId;
    try {
      let res = null;
      res = await axios.delete(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 删除函件预约-管理员端 */
  async deleteReservation_manager({ dispatch }, procInstId) {
    let url = "/rocApi/roc/process/instance/delete/" + procInstId;
    try {
      let res = null;
      res = await axios.delete(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 完全删除函件预约(开发人员使用) */
  async deepDeleteReservation({ dispatch }, procInstId) {
    let url = "/rocApi/roc/process/instance/" + procInstId;
    try {
      let res = null;
      res = await axios.delete(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询申请人Id */
  async getApplId({ dispatch }, loginId) {
    let url = "/rocApi/roc/visitor/users/info/" + loginId;
    try {
      let res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询受访人单位列表 */
  async getOrgList({ dispatch }, id) {
    let url = "/passApi/check/groups/admin?id=" + id;
    try {
      let res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询受访单位人员信息 */
  async hostSearch({ dispatch }, { value, orgId }) {
    let url = "/rocApi/roc/visitor/users/" + orgId + "?name=" + value;
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询受访人单位信息 */
  async getHostGroup({ dispatch }, { orgId, groupId, id }) {
    /* let url = '/shiroApi/themselvesInfo?id=' + id + '&pipe=loginId' */
    let url = "/shiroApi/group/list?page=0&size=10&type=&&id=";
    try {
      let res = null;
      res = await axios.post(url, {
        searchParam: {
          id: {
            index: "1",
            order: "DESC",
            operators: [
              {
                keyword: groupId,
                operator: "EQ",
                matchType: "NONE"
              }
            ]
          }
        }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询受访人信息 */
  async getHostInfo({ dispatch }, id) {
    let url = "/shiroApi/user/list?page=0&size=10";
    try {
      let res = null;
      res = await axios.post(url, {
        searchParam: {
          loginId: {
            index: 1,
            operators: [
              {
                keyword: id,
                matchType: "NONE",
                operator: "EQ"
              }
            ],
            order: "DESC"
          }
        }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询申请人个人信息 */
  async getApplInfo({ dispatch }, loginId) {
    let url = "/shiroApi/user/list?page=0&size=10";
    try {
      let res = null;
      res = await axios.post(url, {
        searchParam: {
          loginId: {
            index: 1,
            operators: [
              {
                keyword: loginId,
                matchType: "NONE",
                operator: "EQ"
              }
            ],
            order: "DESC"
          }
        }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询已提交函件预约表单信息 */
  async getFormData({ dispatch }, config) {
    let procInstId = config.procInstId;
    let formKey = config.taskConfig.relevant.form[0].formKey;
    let url = "/rocApi/roc/form/" + procInstId + "/" + formKey + "/submited";
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 导出函件预约信息为PDF */
  async exportPdf({ dispatch }, config) {
    let procInstId = config.procInstId;
    let formKey = config.taskConfig.relevant.form[0].formKey;
    let url =
      "/rocApi/roc/file/down/scan?formKey=" +
      formKey +
      "&processId=" +
      procInstId;
    try {
      let res = null;
      res = await axios({ method: "get", url: url, responseType: "blob" });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询是否有上传的Pdf */
  async findUploadPdf({ dispatch }, config) {
    let procInstId = config.procInstId;
    let fileKey = config.taskConfig.relevant.file[0].fileKey;
    let url = "/rocApi/roc/file/" + procInstId + "/" + fileKey;
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 下载上传的PDF */
  async downloadPdf({ dispatch }, config) {
    let procInstId = config.procInstId;
    let fileKey = config.taskConfig.relevant.file[0].fileKey;
    let url =
      "/rocApi/roc/file/download?fileKey=" +
      fileKey +
      "&processId=" +
      procInstId;
    try {
      let res = null;
      res = axios({ method: "get", url: url, responseType: "blob" });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 下载自助登记信息说明 */
  async getSelfSignFile({ dispatch }, procInstId) {
    let url =
      "/rocApi/roc/file/down/help?formKey=spava_pass-control_form_act-cfg&processId=" +
      procInstId;
    try {
      let res = null;
      res = await axios({ method: "get", url: url, responseType: "blob" });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 管理员查询审核函件预约任务 */
  async getReviewTask({ dispatch }, config) {
    let url = "/rocApi/roc/task/review/todo";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 读取函件预约信息 */
  async readReservation({ dispatch }, procInstId) {
    let url = "/rocApi/roc/task/his/" + procInstId;
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 管理员签收任务 */
  async signTask({ dispatch }, config) {
    let url = "/rocApi/roc/task/claim";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询自助登记二维码 */
  async getSignCode({ dispatch }, procInstId) {
    let url = "/rocApi/roc/qrCode/" + procInstId;
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询表单定义信息 */
  async getFormDef({ dispatch }, formKey) {
    let url = "/rocApi/roc/form/" + formKey + "/definition";
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询文件定义信息 */
  async getFileDef({ dispatch }, fileKey) {
    let url = "/rocApi/roc/file/" + fileKey + "/definition";
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 上传文件 */
  async uploadPdf({ dispatch }, formData) {
    let url = "/rocApi/roc/file/upload";
    try {
      let res = null;
      res = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 保存函件预约相关信息 */
  async saveForm({ dispatch }, params) {
    let url = "/rocApi/roc/form/upload";
    try {
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 提交函件预约 */
  async submitTask({ dispatch }, config) {
    let url = "/rocApi/roc/task/commen";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 管理员完成审核函件预约任务 */
  async completeReviewTask({ dispatch }, config) {
    let url = "/rocApi/roc/task/review";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 保存函件预约附言 */
  async saveComment({ dispatch }, config) {
    let url = "/rocApi/roc/comment";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询保存的函件预约附言 */
  async getSaveComment({ dispatch }, config) {
    let url =
      "/rocApi/roc/" + config.taskId + "/" + config.procInstId + "/comment";
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询该函件预约的附言列表 */
  async getCommentList({ dispatch }, procInstId) {
    let url = "/rocApi/roc/" + procInstId + "/comment/list";
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取到访客车辆列表信息 */
  async getVisitorList({ dispatch }, { pagination, procInstId }) {
    let url = "/rocApi/roc/form/data/vel/list";
    try {
      let res = null;
      res = await axios.post(url, {
        formKey: "spava_pass-control_form_act-cfg",
        procInstId: procInstId,
        pagingStart: (pagination.page - 1) * pagination.rowsPerPage,
        pagingSize: pagination.rowsPerPage
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 新增访客 */
  async addVisitor({ dispatch }, config) {
    let url = "/rocApi/roc/form/data/vel";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 删除访客 */
  async deleteVisitor({ dispatch }, param) {
    let url = "/rocApi/roc/form/data/vel";
    try {
      let res = null;
      res = await axios.delete(url, { data: param });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 编辑访客 */
  async editVisitor({ dispatch }, config) {
    let url = "/rocApi/roc/form/data/vel";
    try {
      let res = null;
      res = await axios.put(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询访客 */
  async searchVisitor({ dispatch }, config) {
    let url = "/rocApi/roc/form/data/vel/detail";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 自助登记模块相关接口 */
  /* 查询预约信息 */
  async selfSign_getReservationInfo({ dispatch }, procInstId) {
    let url = "/rocApi/roc/self/register/obgrp?procInstId=" + procInstId;
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 验证码获取临时token */
  async selfSign_getTmpToken({ dispatch }) {
    // let url = "/verifyApi/validate/token";
    let url = "/verifyApi/validate/token";
    try {
      let res = null;
      res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取验证码 */
  async selfSign_getVerifyMsg({ dispatch }, { key, phone, hash }) {
    let url =
      "/verifyApi/validate/verify/" +
      key +
      "/pipe/msg?to=" +
      phone +
      "&premsg=" +
      hash;
    try {
      let res = null;
      res = await axios.post(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取图片验证码 */
  async selfSign_getVerifyMsgPic({ dispatch }, { key }) {
    let url = "/verifyApi/validate/verify/" + key + "/pipe/premsg";
    try {
      let res = null;
      res = await axios.post(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 验证验证码正确性 */
  async selfSign_checkVerify({ dispatch }, config) {
    let url = "/verifyApi/validate/check";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 自助登记提交表单 */
  async selfSign_submit({ dispatch }, { verifyKey, openId, config }) {
    let url =
      "/rocApi/roc/self/register/page?verifyKey=" +
      verifyKey +
      "&openId=" +
      openId;
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取到自助登记访客车辆列表信息 */
  async selfSign_getVisitorList({ dispatch }, { pagination, procInstId }) {
    let url = "/rocApi/roc/self/register/list";
    try {
      let res = null;
      res = await axios.post(url, {
        formKey: "spava_pass-control_form_act-cfg",
        procInstId: procInstId,
        pagingStart: (pagination.page - 1) * pagination.rowsPerPage,
        pagingSize: pagination.rowsPerPage
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 自助登记新增车辆 */
  async selfSign_addVisitor({ dispatch }, config) {
    let url = "/rocApi/roc/self/register";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 自助登记删除车辆 */
  async selfSign_deleteVisitor({ dispatch }, param) {
    let url = "/rocApi/roc/self/register";
    try {
      let res = null;
      res = await axios.delete(url, { data: param });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 自助登记编辑车辆 */
  async selfSign_editVisitor({ dispatch }, config) {
    let url = "/rocApi/roc/self/register";
    try {
      let res = null;
      res = await axios.put(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 自助登记查询车辆 */
  async selfSign_searchVisitor({ dispatch }, config) {
    let url = "/rocApi/roc/self/register/detail";
    try {
      let res = null;
      res = await axios.post(url, config);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async reviewVehicles({ dispatch }, param) {
    let url = "/rocApi/roc/self/register/review";
    try {
      let res = null;
      res = await axios.put(url, {
        formKey: "spava_pass-control_form_act-cfg",
        procInstId: param.procInstId,
        reviewStatus: param.status,
        velInFormList: param.array
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
